import {updateLabelConfig} from '../../../../data/labelInfos/index.js'
import ConfigCheckbox from '../ConfigCheckbox.js'
import {UPS} from '../../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from '../useLabelProperty.js'

const LABEL_PROPERTY = 'shipper_release'
const VALID_SHIPPER_TYPES = [UPS]

export default function ShipperRelease() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = ShipperRelease.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigCheckbox
      label="Shipper Release"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

ShipperRelease.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
